/* eslint-disable react-refresh/only-export-components --
   React Router reads Route elements, not components, so this module's export
   cannot be a component and the lazy pages cannot move out of the file that
   registers them. */
import { lazy } from "react";
import { Navigate, Outlet, Route } from "react-router";

import {
    VALIDATOR_DETAIL_SEGMENT,
    VALIDATOR_PERFORMANCE_SEGMENT,
    VALIDATOR_RUNS_SEGMENT,
    VALIDATORS_SEGMENT,
} from "./validatorPaths";

const AdminValidators = lazy(() => import("./AdminValidators"));

const AdminValidatorDetails = lazy(() => import("./AdminValidatorDetails"));

const ValidatorDetailTabRoute = lazy(() =>
    import("./AdminValidatorDetails").then((module) => ({
        default: module.ValidatorDetailTabRoute,
    }))
);

const ValidatorPerformanceTabRoute = lazy(
    () => import("./ValidatorPerformanceTabRoute")
);

const ValidatorRunsTabRoute = lazy(() => import("./ValidatorRunsTabRoute"));

export const validatorAdminRoutes = (
    <Route path={VALIDATORS_SEGMENT} element={<Outlet />}>
        <Route index element={<AdminValidators />} />
        <Route path=":name" element={<AdminValidatorDetails />}>
            <Route
                index
                element={<Navigate to={VALIDATOR_DETAIL_SEGMENT} replace />}
            />
            <Route
                path={VALIDATOR_DETAIL_SEGMENT}
                element={<ValidatorDetailTabRoute />}
            />
            <Route
                path={VALIDATOR_PERFORMANCE_SEGMENT}
                element={<ValidatorPerformanceTabRoute />}
            />
            <Route
                path={VALIDATOR_RUNS_SEGMENT}
                element={<ValidatorRunsTabRoute />}
            />
        </Route>
    </Route>
);
